import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';

import { checkAuth } from '../../../actions';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { XIcon } from '../ui/icons';

// Layout shell for every /admin page — replaces newadmin/DashboardContainer.
// Deliberately loads NO Metronic assets; styling comes from Tailwind/daisyUI
// scoped via the lg-modern-page <html> class (see src/index.css).
const AdminShell = ({ title, actions, children, maxWidth = 'max-w-6xl' }) => {
    const user = useSelector((s) => s.user);
    const dispatch = useDispatch();
    const [drawerOpen, setDrawerOpen] = useState(false);

    // Same auth wiring as DashboardContainer.componentDidMount: checkAuth
    // redirects to /login itself when unauthenticated and refetches
    // applications + events on success.
    useEffect(() => {
        if (user.token == null) {
            dispatch(checkAuth());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div data-theme="loangateway" className="min-h-screen w-full" style={{ backgroundColor: '#F5F6FA' }}>
            <Helmet defer={false}>
                {/*
                  Toggle the modern-page styles via <html className> — html
                  attributes are correctly removed by react-helmet on unmount,
                  so nothing leaks onto the Metronic /admin pages.
                */}
                <html className="lg-modern-page" />
                <meta charSet="utf-8" />
                <title>{title ? `${title} | LoanGateway Admin` : 'Admin | LoanGateway'}</title>
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1, shrink-to-fit=no"
                />
            </Helmet>

            <div className="flex">
                <Sidebar variant="desktop" />

                {drawerOpen ? (
                    <div className="fixed inset-0 z-40 lg:hidden" role="dialog" aria-modal="true">
                        <div
                            className="absolute inset-0"
                            style={{ backgroundColor: 'rgba(15, 17, 26, 0.55)', backdropFilter: 'blur(2px)' }}
                            onClick={() => setDrawerOpen(false)}
                        />
                        <div className="absolute inset-y-0 left-0 w-72 max-w-[85vw] shadow-2xl">
                            <Sidebar variant="drawer" onNavigate={() => setDrawerOpen(false)} />
                            <button
                                type="button"
                                onClick={() => setDrawerOpen(false)}
                                aria-label="Close menu"
                                className="absolute top-4 right-3 rounded-lg p-1.5 text-[#9CA0AE] hover:text-white transition-colors"
                            >
                                <XIcon className="h-5 w-5" />
                            </button>
                        </div>
                    </div>
                ) : null}

                <main className="flex-1 min-w-0 flex flex-col min-h-screen">
                    <Topbar title={title} actions={actions} onHamburger={() => setDrawerOpen(true)} />

                    <div className="flex-1 px-4 sm:px-6 lg:px-8 py-6">
                        <div className={`${maxWidth} mx-auto`}>{children}</div>
                    </div>

                    <footer className="text-center text-xs text-[#9CA3AF] py-6 px-4">
                        © {new Date().getFullYear()} LoanGateway
                    </footer>
                </main>
            </div>
        </div>
    );
};

export default AdminShell;
